// ================================================================
// Constantes y Comandos ESC/POS (alineado con generateThermalRefundReceipt)
// ================================================================
const ESC = '\x1B';
const GS = '\x1D';
const FS = '\x1C';

const CMD = {
  INIT: ESC + '@',
  LF: '\n',
  ALIGN_LEFT: ESC + 'a' + '\x00',
  ALIGN_CENTER: ESC + 'a' + '\x01',
  ALIGN_RIGHT: ESC + 'a' + '\x02',
  BOLD_ON: ESC + 'E' + '\x01',
  BOLD_OFF: ESC + 'E' + '\x00',
  TEXT_SIZE_NORMAL: GS + '!' + '\x00',
  TEXT_SIZE_DOUBLE_WIDTH: GS + '!' + '\x01',
  TEXT_SIZE_DOUBLE_HEIGHT: GS + '!' + '\x10',
  TEXT_SIZE_DOUBLE_WIDTH_HEIGHT: GS + '!' + '\x11',
  TEXT_SIZE_CONDENSED: ESC + '\x0F',
  TEXT_SIZE_NORMAL_WIDTH: ESC + '\x14',
  CUT_PAPER_FULL: GS + 'V' + '\x00',
  PRINT_NV_LOGO: (keyCode, mode = 0) => FS + 'p' + String.fromCharCode(keyCode) + String.fromCharCode(mode),
  BARCODE_HEIGHT_DEFAULT: GS + 'h' + '\x50',
  BARCODE_WIDTH_MODULE_DEFAULT: GS + 'w' + '\x02',
  HRI_POSITION_BELOW: GS + 'H' + '\x02',
  SET_CODE_PAGE_PC850: ESC + 't' + '\x02'
};

// ================================================================
// Utilidades
// ================================================================
function padRight(str, length, char = ' ') {
  return String(str).padEnd(length, char);
}
function padLeft(str, length, char = ' ') {
  return String(str).padStart(length, char);
}
function padCenter(str, length, char = ' ') {
  const padding = Math.max(0, length - String(str).length);
  const leftPad = Math.floor(padding / 2);
  const rightPad = padding - leftPad;
  return char.repeat(leftPad) + str + char.repeat(rightPad);
}
function parseNumber(value) {
  if (value === null || value === undefined || String(value).trim() === '') return 0;
  return Number(String(value).replace(/,/g, ''));
}
function formatCurrencyESCPOS(value) {
  const num = parseNumber(value);
  return `RD$${num.toLocaleString('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
function wrapText(text, maxWidth) {
  if (String(text).length <= maxWidth) return [String(text)];
  const words = String(text).split(' ');
  const lines = [];
  let current = '';
  for (const w of words) {
    if (w.length > maxWidth) {
      if (current) { lines.push(current); current=''; }
      let t = w;
      while (t.length > maxWidth) { lines.push(t.substring(0,maxWidth)); t = t.substring(maxWidth); }
      current = t;
      continue;
    }
    if ((current + (current? ' ':'') + w).length <= maxWidth) {
      current += (current? ' ':'') + w;
    } else { lines.push(current); current = w; }
  }
  if (current) lines.push(current);
  return lines;
}
function formatDate(dateString) {
  if (!dateString) return 'No registrada';
  try {
    return new Date(dateString).toLocaleString('es-DO', {
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true
    });
  } catch { return 'Fecha inválida'; }
}

// ================================================================
// Recibo Compacto 32 caracteres (58mm)
// ================================================================
async function generateCompactPaymentReceipt32(paymentData) {
  const paperWidth = 32;
  const singleLine = '-'.repeat(paperWidth);
  const doubleLine = '='.repeat(paperWidth);
  let r = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  r += CMD.ALIGN_CENTER;
  r += CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON;
  r += CMD.PRINT_NV_LOGO(1,0) + CMD.LF;
  r += "D'PRINCESS (PRÁCTICA)" + CMD.LF;
  r += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  r += 'Foto Films (Práctica)' + CMD.LF;
  r += 'Tel: (809)588-2700 (Práctica)' + CMD.LF;
  r += doubleLine + CMD.LF;

  // Disclaimer
  r += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  r += '*** VERSIÓN DE PRÁCTICA ***' + CMD.LF;
  r += CMD.BOLD_OFF + 'Información ficticia' + CMD.LF;
  r += doubleLine + CMD.LF;

  r += CMD.ALIGN_CENTER + CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  r += 'RECIBO PAGO (PRÁCTICA)' + CMD.LF;
  r += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL + CMD.LF;

  r += CMD.ALIGN_LEFT;
  r += `No.: ${paymentData.paymentReceipt?.receiptDocumentNumber || 'N/A'} (Práctica)` + CMD.LF;
  r += `Fecha: ${formatDate(paymentData.paymentReceipt?.paymentDate || Date.now())} (Práctica)` + CMD.LF;
  if (paymentData.invoiceData?.clientName) {
    r += `Cliente: ${String(paymentData.invoiceData.clientName).substring(0,20)} (Práctica)` + CMD.LF;
  }
  if (paymentData.invoiceData?.invoiceNumber) {
    r += `Factura: ${paymentData.invoiceData.invoiceNumber} (Práctica)` + CMD.LF;
  }
  if (paymentData.debitNote?.debitNoteNumber) {
    r += `N.Débito: ${paymentData.debitNote.debitNoteNumber} (Práctica)` + CMD.LF;  
  }
  r += singleLine + CMD.LF;

  r += CMD.BOLD_ON + 'DETALLES:' + CMD.BOLD_OFF + CMD.LF;
  if (Array.isArray(paymentData.paymentReceiptDetails)) {
    paymentData.paymentReceiptDetails.forEach(d => {
      const debit = paymentData.debitNoteDetails?.find(dd => dd.debitNoteDetailID === d.debitNoteDetailID);
      const concept = debit?.concept || 'Cargo';
      r += concept.substring(0,18) + CMD.LF;
      r += formatCurrencyESCPOS(d.amountPaid) + CMD.LF;
    });
  }
  r += singleLine + CMD.LF;

  const totalLabelWidth = paperWidth - 12;
  r += CMD.BOLD_ON + padRight('TOTAL:', totalLabelWidth) + padLeft(formatCurrencyESCPOS(paymentData.paymentReceipt?.totalAmountPaid),12) + CMD.LF + CMD.BOLD_OFF;
  if (paymentData.paymentReceipt?.paymentMethod) {
    r += padRight('METODO:', totalLabelWidth) + padLeft(String(paymentData.paymentReceipt.paymentMethod).toUpperCase(),12) + CMD.LF;
  }
  if (paymentData.paymentReceipt?.referenceNumber) {
    r += padRight('REF:', totalLabelWidth) + padLeft(String(paymentData.paymentReceipt.referenceNumber).substring(0,12),12) + CMD.LF;
  }

  r += CMD.LF + CMD.ALIGN_CENTER;
  r += '¡Gracias por su pago! (Práctica)' + CMD.LF;
  r += CMD.LF + CMD.LF + CMD.CUT_PAPER_FULL;
  return r;
}

// ================================================================
// Recibo Estándar 48 caracteres (80mm reducido)
// ================================================================
async function generateStandardPaymentReceipt48(paymentData) {
  const paperWidth = 47; // similar a refund
  const doubleLine = '='.repeat(paperWidth);
  const singleLine = '-'.repeat(paperWidth);
  const dotLine = '.'.repeat(paperWidth);
  const labelChars = 18;
  const valueChars = paperWidth - labelChars - 1;
  let r = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  r += CMD.ALIGN_CENTER + CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON + CMD.PRINT_NV_LOGO(1,0) + CMD.LF;
  r += "D'PRINCESS STGO. (PRÁCTICA)" + CMD.LF;
  r += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  r += 'Foto Films (Práctica)' + CMD.LF;
  r += doubleLine + CMD.LF;

  // Disclaimer
  r += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  r += '*** VERSIÓN DE PRÁCTICA ***' + CMD.LF;
  r += CMD.BOLD_OFF + 'Información ficticia - Rama Practica' + CMD.LF;
  r += doubleLine + CMD.LF;

  r += CMD.ALIGN_CENTER + CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON + 'RECIBO DE PAGO (PRÁCTICA)' + CMD.LF + CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL + CMD.LF;

  r += CMD.ALIGN_LEFT;
  r += padRight('No. Recibo:', labelChars) + ' ' + padLeft(paymentData.paymentReceipt?.receiptDocumentNumber || 'N/A', valueChars) + ' (Práctica)' + CMD.LF;
  r += padRight('Fecha Pago:', labelChars) + ' ' + padLeft(formatDate(paymentData.paymentReceipt?.paymentDate || Date.now()), valueChars) + ' (Práctica)' + CMD.LF;
  r += padRight('Fecha de Emisión:', labelChars) + ' ' + padLeft(formatDate(Date.now()), valueChars) + ' (Práctica)' + CMD.LF;
  if (paymentData.invoiceData?.invoiceNumber) {
    r += padRight('Factura:', labelChars) + ' ' + padLeft(paymentData.invoiceData.invoiceNumber, valueChars) + ' (Práctica)' + CMD.LF;
  }
  if (paymentData.debitNote?.debitNoteNumber) {
    r += padRight('Nota Débito:', labelChars) + ' ' + padLeft(paymentData.debitNote.debitNoteNumber, valueChars) + ' (Práctica)' + CMD.LF;
  }
  if (paymentData.invoiceData?.clientName) {
    r += padRight('Cliente:', labelChars) + ' ' + padLeft(String(paymentData.invoiceData.clientName).substring(0,valueChars), valueChars) + ' (Práctica)' + CMD.LF;
  }
  if (paymentData.paymentReceipt?.registeredByUserName) {
    r += padRight('Atendido por:', labelChars) + ' ' + padLeft(String(paymentData.paymentReceipt.registeredByUserName).substring(0,valueChars), valueChars) + ' (Práctica)' + CMD.LF;
  }
  r += singleLine + CMD.LF;

  r += CMD.BOLD_ON + 'DETALLES DEL PAGO:' + CMD.BOLD_OFF + CMD.LF;
  r += padRight('Concepto', 24) + ' ' + padLeft('Monto', 12) + CMD.LF;
  r += dotLine + CMD.LF;

  if (Array.isArray(paymentData.paymentReceiptDetails)) {
    paymentData.paymentReceiptDetails.forEach(d => {
      const debit = paymentData.debitNoteDetails?.find(dd => dd.debitNoteDetailID === d.debitNoteDetailID);
      const concept = debit?.concept || 'Cargo adicional';
      const amount = formatCurrencyESCPOS(d.amountPaid);
      const lines = wrapText(concept, 24);
      lines.forEach((line,i) => {
        if (i===0) {
          r += padRight(line,24) + ' ' + padLeft(amount,12) + CMD.LF;
        } else {
          r += padRight(line,24) + ' ' + ' '.repeat(12) + CMD.LF;
        }
      });
    });
  }
  r += dotLine + CMD.LF;

  r += CMD.BOLD_ON + 'RESUMEN:' + CMD.BOLD_OFF + CMD.LF;
  r += padRight('Total Pagado:', labelChars+2) + padLeft(formatCurrencyESCPOS(paymentData.paymentReceipt?.totalAmountReceived), valueChars-2) + CMD.LF;
  r += padRight('Método:', labelChars+2) + padLeft(String(paymentData.paymentReceipt?.paymentMethod || 'N/D').toUpperCase(), valueChars-2) + CMD.LF;
  if (paymentData.paymentReceipt?.referenceNumber) {
    r += padRight('Referencia:', labelChars+2) + padLeft(String(paymentData.paymentReceipt.referenceNumber).substring(0,valueChars-2), valueChars-2) + CMD.LF;
  }
  if (paymentData.paymentReceipt?.notes) {
    r += singleLine + CMD.LF + CMD.BOLD_ON + 'NOTAS:' + CMD.BOLD_OFF + CMD.LF;
    wrapText(paymentData.paymentReceipt.notes, paperWidth).forEach(l=> r+= l + CMD.LF);
  }
  r += doubleLine + CMD.LF;
  r += CMD.ALIGN_CENTER + '¡Gracias por su pago! (Práctica)' + CMD.LF + CMD.LF;
  // Espacios
  r += CMD.LF;
  r += CMD.LF;
  r += CMD.CUT_PAPER_FULL;

  return r;
}

// ================================================================
// Recibo Premium 80 caracteres
// ================================================================
async function generatePremiumPaymentReceipt80(paymentData) {
  const paperWidth = 80;
  const doubleLine = '='.repeat(paperWidth);
  const singleLine = '-'.repeat(paperWidth);
  const dotLine = '.'.repeat(paperWidth);
  let r = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  r += CMD.ALIGN_CENTER + CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON + CMD.PRINT_NV_LOGO(1,0) + CMD.LF;
  r += "D'PRINCESS STGO. (PRÁCTICA)" + CMD.LF;
  r += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  r += 'Foto Films (Práctica)' + CMD.LF;
  r += 'Tel: (809)588-2700 | WhatsApp: (809)491-2700 (Práctica)' + CMD.LF;
  r += 'Email: info@dprincess.com (Práctica)' + CMD.LF;
  r += 'Dirección: Plaza Comercial Michelle, Mód.105, Santiago (Práctica)' + CMD.LF;
  r += doubleLine + CMD.LF;

  // Disclaimer
  r += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  r += '*** VERSIÓN DE PRÁCTICA - INFORMACIÓN FICTICIA ***' + CMD.LF;
  r += CMD.BOLD_OFF + 'No representa datos reales. Rama Practica.' + CMD.LF;
  r += doubleLine + CMD.LF;

  r += CMD.ALIGN_CENTER + CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON + 'COMPROBANTE DE PAGO (PRÁCTICA)' + CMD.LF + CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL + CMD.LF;

  const colWidth = Math.floor(paperWidth/2) - 1;
  r += CMD.ALIGN_LEFT;
  r += padRight(`Recibo: ${paymentData.paymentReceipt?.receiptDocumentNumber || 'N/A'} (Práctica)`, colWidth) + ' ' + padLeft(`Fecha Pago: ${formatDate(paymentData.paymentReceipt?.paymentDate || Date.now())} (Práctica)`, colWidth) + CMD.LF;
  if (paymentData.invoiceData?.invoiceNumber) {
    r += padRight(`Factura: ${paymentData.invoiceData.invoiceNumber} (Práctica)`, colWidth) + ' ' + padLeft(`Nota Débito: ${paymentData.debitNote?.debitNoteNumber || 'N/A'} (Práctica)`, colWidth) + CMD.LF;
  }
  if (paymentData.paymentReceipt?.registeredByUserName) {
    r += padRight(`Atendido: ${paymentData.paymentReceipt.registeredByUserName} (Práctica)`, colWidth) + ' ' + padLeft(`Método: ${(paymentData.paymentReceipt?.paymentMethod || 'N/D')} (Práctica)`, colWidth) + CMD.LF;
  }
  if (paymentData.invoiceData?.clientName) {
    r += padRight(`Cliente: ${paymentData.invoiceData.clientName} (Práctica)`, paperWidth) + CMD.LF;
  }
  r += singleLine + CMD.LF;

  r += CMD.BOLD_ON + 'DETALLE DE CARGOS PAGADOS:' + CMD.BOLD_OFF + CMD.LF;
  r += padRight('Descripción del Cargo', 45) + ' ' + padCenter('Monto', 15) + ' ' + padLeft('Pagado', 14) + CMD.LF;
  r += dotLine + CMD.LF;

  if (Array.isArray(paymentData.paymentReceiptDetails)) {
    paymentData.paymentReceiptDetails.forEach(d => {
      const debit = paymentData.debitNoteDetails?.find(dd => dd.debitNoteDetailID === d.debitNoteDetailID);
      const concept = (debit?.concept || 'Cargo adicional');
      const amount = parseNumber(d.amountPaid);
      const lines = wrapText(concept,45);
      lines.forEach((line,i)=>{
        if (i===0) {
          r += padRight(line,45) + ' ' + padCenter(formatCurrencyESCPOS(amount),15) + ' ' + padLeft(formatCurrencyESCPOS(amount),14) + CMD.LF;
        } else {
          r += padRight(line,45) + ' ' + ' '.repeat(15) + ' ' + ' '.repeat(14) + CMD.LF;
        }
      });
    });
  }
  r += dotLine + CMD.LF;

  r += CMD.BOLD_ON + padRight('TOTAL PAGADO:', paperWidth - 16) + padLeft(formatCurrencyESCPOS(paymentData.paymentReceipt?.totalAmountPaid),16) + CMD.LF + CMD.BOLD_OFF;
  r += singleLine + CMD.LF;

  if (paymentData.paymentReceipt?.referenceNumber) {
    r += 'Referencia: ' + paymentData.paymentReceipt.referenceNumber + CMD.LF;
  }
  if (paymentData.paymentReceipt?.notes) {
    r += 'Notas: ' + CMD.LF;
    wrapText(paymentData.paymentReceipt.notes, paperWidth).forEach(l=> r+= l + CMD.LF);
  }

  // Código de barras opcional (Code128) basado en número de recibo
  if (paymentData.paymentReceipt?.receiptDocumentNumber) {
    const code = String(paymentData.paymentReceipt.receiptDocumentNumber).trim();
    if (code.length>0 && code.length<256) {
      r += CMD.ALIGN_CENTER;
      r += CMD.BARCODE_HEIGHT_DEFAULT + CMD.BARCODE_WIDTH_MODULE_DEFAULT + CMD.HRI_POSITION_BELOW;
      let code128 = GS + 'k' + '\x49';
      code128 += String.fromCharCode(code.length) + code;
      r += code128 + CMD.LF + CMD.LF;
    }
  }

  r += CMD.ALIGN_CENTER + doubleLine + CMD.LF;
  r += CMD.BOLD_ON + '¡PAGO REGISTRADO EXITOSAMENTE! (PRÁCTICA)' + CMD.BOLD_OFF + CMD.LF + CMD.LF;
  r += 'Conserve este comprobante para sus registros. (Práctica)' + CMD.LF;
  r += 'Servicio al cliente: WhatsApp (809)491-2700 (Práctica)' + CMD.LF;
  r += 'Email: soporte@dprincess.com (Práctica)' + CMD.LF;
  r += CMD.LF + CMD.LF + CMD.CUT_PAPER_FULL;
  return r;
}

// ================================================================
// Función principal inteligente (selección automática según ancho)
// ================================================================
async function generateThermalPaymentReceipt(paymentData, paperWidthCharsProvided) {
  if (!paymentData || !paymentData.paymentReceipt) {
    console.error('Datos de pago inválidos:', paymentData);
    return '';
  }

  let paperWidthChars = parseInt(paperWidthCharsProvided, 10);
  if (isNaN(paperWidthChars) || paperWidthChars <= 0) {
    console.warn(`Ancho de papel inválido ('${paperWidthCharsProvided}'), usando 48 por defecto.`);
    paperWidthChars = 48;
  }
  // Ajuste similar al de reembolso (compensar caracteres efectivos)
  paperWidthChars = paperWidthChars - 10;
  console.log('Generando recibo de pago para ancho:', paperWidthChars);

  if (paperWidthChars <= 32) {
    return await generateCompactPaymentReceipt32(paymentData);
  } else if (paperWidthChars <= 48) {
    return await generateStandardPaymentReceipt48(paymentData);
  } else {
    return await generatePremiumPaymentReceipt80(paymentData);
  }
}

// Exports
export {
  generateCompactPaymentReceipt32,
  generateStandardPaymentReceipt48,
  generatePremiumPaymentReceipt80
};

export default generateThermalPaymentReceipt;
